<template>
  <el-select popper-class="table-select-cl" :popper-append-to-body="false" ref="select" v-model="agents" size="small" clearable multiple collapse-tags placeholder="请选择" @remove-tag="removeTag" @visible-change="visibleChange">
    <template #empty>
      <div class="sc-table-select__table"  :style="{width: tableWidth+'px'}" v-loading="loading">
        <div class="sc-table-select__header">
          <el-form :inline="true" :model="formData">
            <el-form-item>
              <el-input v-model="formData.company" placeholder="名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="formSubmit">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table ref="table" :data="tableData" :height="245" @select="select" @select-all="selectAll" @row-click="rowClick">
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column prop="company" label="名称"></el-table-column>
          <el-table-column prop="superior.company" label="上级"></el-table-column>
        </el-table>
        <div class="sc-table-select__page" style="display: flex">
          <el-select :popper-append-to-body="false" style="width: 100px" v-model="limit" size="mini">
            <el-option
              v-for="item in limitArr"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-pagination :pager-count="5" small background layout="total,prev,pager,next" :total="total" :page-size="limit" :current-page="currentPage" @current-change="currentChange"></el-pagination>
        </div>
        <div style="float: right;margin: 10px">
          <el-button type="primary" @click="tableBlur">确 定</el-button>
        </div>
      </div>
    </template>
  </el-select>
</template>

<script>
import {fetchAgentList} from '../api/agent'

export default {
  data () {
    return {
      loading: false,
      agents: [],
      tableData: [],
      limit: 10,
      total: 0,
      currentPage: 1,
      defaultProps: {
        label: 'company',
        value: 'user_id'
      },
      formData: {},
      limitArr: [{
        label: '10条/页',
        value: 10
      }, {
        label: '20条/页',
        value: 20
      }, {
        label: '50条/页',
        value: 50
      }]
    }
  },
  watch: {
    agents (newV) {
      this.autoCurrentLabel()
      if (newV.length > 0) {
        const ids = newV.map(item => item.user_id)
        this.$emit('input', ids)
      } else {
        this.$emit('input', [])
      }
    },
    value: function (val, old) {
      if (!val) {
        this.agents = []
      }
    },
    limit () {
      this.currentPage = 1
      this.getData()
    }
  },
  created () {
    this.autoCurrentLabel()
  },
  computed: {
    tableWidth () {
      if (!window || !window.innerWidth || window.innerWidth > 800) return 800
      return window.innerWidth
    }
  },
  props: ['value'],
  methods: {
    tableBlur () {
      this.$refs.select.blur()
    },
    parseData: function (res) {
      return {
        data: res,
        // 分析行数据字段结构
        rows: res.data,
        // 分析总数字段结构
        total: res.total,
        // 分析描述字段结构
        msg: res.message,
        // 分析状态字段结构
        code: res.code
      }
    },
    // 表格显示隐藏回调
    visibleChange (visible) {
      if (visible) {
        this.currentPage = 1
        this.formData = {}
        this.getData()
      } else {
        this.autoCurrentLabel()
      }
    },
    // 获取表格数据
    async getData () {
      this.loading = true
      const reqData = {
        page: this.currentPage,
        limit: this.limit,
        o: 'user_id,desc'
      }
      let q = []
      if (this.formData.company) {
        q.push(['like', 'company', '%' + this.formData.company + '%'].join(','))
      }
      reqData.q = q.join('&')
      const res = await fetchAgentList(reqData)
      const parseData = this.parseData(res)
      this.tableData = parseData.rows
      this.total = parseData.total
      this.loading = false
      // 表格默认赋值
      this.$nextTick(() => {
        if (!this.agents || !this.agents.length) return
        this.agents.forEach(row => {
          const setrow = this.tableData.filter(item => item[this.defaultProps.value] === row[this.defaultProps.value])
          if (setrow.length > 0) {
            this.$refs.table.toggleRowSelection(setrow[0], true)
          }
        })
      })
    },
    // 插糟表单提交
    formSubmit () {
      this.currentPage = 1
      this.getData()
    },
    // 分页刷新表格
    currentChange (e) {
      this.currentPage = e
      this.getData()
    },
    // 自动模拟options赋值
    autoCurrentLabel () {
      this.$nextTick(() => {
        this.$refs.select.selected.forEach(item => {
          item.currentLabel = item.value[this.defaultProps.label]
        })
      })
    },
    // 表格点击事件
    rowClick (row, column, event) {
      // 多选选中行
      // 根据id判断当前点击的是否被选中
      const selected = this.agents.some(item => item.user_id === row.user_id)
      if (!selected) {
        // 选择
        this.agents.push(row)
        this.$refs.table.toggleRowSelection(row, true)
      } else {
        // 取消
        const finalArr = this.agents.filter((item) => {
          return item.user_id !== row.user_id
        })
        // 取消后剩余选中的
        this.agents = finalArr
        this.$refs.table.toggleRowSelection(row, false)
      }
    },
    // 表格勾选事件
    select (rows, row) {
      const isSelect = rows.length && rows.indexOf(row) !== -1
      if (isSelect) {
        this.agents.push(row)
      } else {
        this.agents.splice(this.agents.findIndex(item => item[this.defaultProps.value] === row[this.defaultProps.value]), 1)
      }
      this.autoCurrentLabel()
    },
    // 表格全选事件
    selectAll (rows) {
      const isAllSelect = rows.length > 0
      if (!this.agents) return
      if (isAllSelect) {
        rows.forEach(row => {
          const isHas = this.agents.find(item => item[this.defaultProps.value] === row[this.defaultProps.value])
          if (!isHas) {
            this.agents.push(row)
          }
        })
      } else {
        this.tableData.forEach(row => {
          const isHas = this.agents.find(item => item[this.defaultProps.value] === row[this.defaultProps.value])
          if (isHas) {
            this.agents.splice(this.agents.findIndex(item => item[this.defaultProps.value] === row[this.defaultProps.value]), 1)
          }
        })
      }
      this.autoCurrentLabel()
    },
    // tags删除后回调
    removeTag (tag) {
      const row = this.findRowByKey(tag[this.defaultProps.value])
      this.$refs.table.toggleRowSelection(row, false)
    },
    // 关键值查询表格数据行
    findRowByKey (value) {
      return this.tableData.find(item => item[this.defaultProps.value] === value)
    },
    // 触发select隐藏
    blur () {
      this.$refs.select.blur()
    }
  }
}
</script>

<style scoped>
.sc-table-select__table {padding:12px;}
.sc-table-select__page {padding-top: 12px;}
.table-select-cl{
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/card/components/AgentTableSelect.vue